<template>
    <Head title="Informations générales" />

    <SettingsLayout :general-settings="generalSettings" :currency="currency">
        <div class="bg-white shadow-lg sm:rounded-md border border-gray-200 my-3 p-4">
            <form class="grid grid-cols-6 gap-4">
                <div class="col-span-3 sm:col-span-3">
                    <jet-label for="amount_penality" value="Montant appliquable pour la pénalité:" />
                    <jet-input
                        id="amount_penality"
                        v-model="form.amount_penality"
                        type="text"
                        class="mt-1 block w-full text-right"
                        autocomplete="amount_penality"
                    />
                    <jet-input-error :message="form.errors.amount_penality" class="mt-2" />
                </div>
                <!-- penalityNumberDays -->
                <div class="col-span-3 sm:col-span-3">
                    <jet-label for="penality_number_days" value="Nombre de jours pour appliquer la pénalité:" />
                    <jet-input
                        id="penality_number_days"
                        v-model="form.penality_number_days"
                        type="text"
                        class="mt-1 block w-full text-right"
                        autocomplete="penality_number_days"
                    />
                    <jet-input-error :message="form.errors.penality_number_days" class="mt-2" />
                </div>
                <!-- tva -->
                <div class="col-span-6 sm:col-span-6">
                    <jet-label for="tva" value="TVA en %:" />
                    <jet-input
                        id="tva"
                        v-model="form.tva"
                        type="text"
                        class="mt-1 block w-full text-right"
                        autocomplete="tva"
                    />
                    <jet-input-error :message="form.errors.tva" class="mt-2" />
                </div>
                <div class="col-span-6 flex items-center justify-end py-3 bg-gray-50 text-right sm:px-2 shadow sm:rounded-bl-md sm:rounded-br-md">
                    <boti-button :loader="form.processing" :disabled="form.processing"
                        @click="updateGeneralSettingInformation()"  class="w-full" color="sky"
                        :class="{ 'opacity-25': form.processing }" text="Mettre à jour"
                    >
                        <i v-if="form.processing" class="fad fa-pencil text-sm"></i>
                        <template #icon>
                            <i class="fad fa-check-circle text-xs ml-1"></i>
                        </template>
                    </boti-button>
                </div>
            </form>
        </div>
    </SettingsLayout>
</template>

<script>
    import JetInput from '@/Jetstream/Input.vue';
    import JetLabel from '@/Jetstream/Label.vue';
    import { Head } from '@inertiajs/inertia-vue3';
    import Textarea from '@/Jetstream/Textarea.vue';
    import BotiButton from '@/Components/Button.vue';
    import JetInputError from '@/Jetstream/InputError.vue';
    import JetFormSection from '@/Jetstream/FormSection.vue';
    import SettingsLayout from '@/Layouts/SettingsLayout.vue';
    import JetActionMessage from '@/Jetstream/ActionMessage.vue';
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';


    export default {
        props: {
            currency: Object,
            generalSettings: Object
        },

        components: {
            Head,
            JetLabel,
            JetInput,
            Textarea,
            BotiButton,
            JetInputError,
            JetFormSection,
            SettingsLayout,
            JetActionMessage,
            JetActionMessage,
            JetSecondaryButton
        },

        data() {
            return {
                form: this.$inertia.form({
                    amount_penality: this.generalSettings.amount_penality,
                    penality_number_days: this.generalSettings.penality_number_days,
                    tva: this.generalSettings.tva,
                })
            }
        },

        methods: {
            updateGeneralSettingInformation() {

                this.form.put(route('settings.update.general'), {
                    errorBag: 'updateGeneralSettingInformation',
                    preserveScroll: true,
                    onSuccess: () =>{
                        this.$swal.fire(
                            'Informations générales',
                            'Informations générales mises à jour avec succès.',
                            'success'
                        )
                        this.resetGeneralSettingInformation()
                    },
                });
            },

            resetGeneralSettingInformation() {
                form.reset();
            }
        }
    }
</script>
